export const serverbaselink = 'https://ziaameliaapi.com';
